var dlgScreen = null;

function ScreeningViewPackage() {
	PanteraScript.PanteraScriptService.GetScreeningPackageItems(pjqSessionId, parseInt(jQuery('#screening-type').val()), ScreeningViewPackageC, onScriptError);
}

function ScreeningViewPackageC(response) {
	var screeningPackage = jQuery.parseJSON(response),
		itemtext = '';
	for (var i = 0; i < screeningPackage.Items.length; i++) {
		itemtext += screeningPackage.Items[i].ItemName + "<br />";
	}
	jQuery('#screening-info-header').html('Package Items Included:');
	jQuery('#screening-item-list').html(itemtext);
	jQuery('#screening-item-name').html(screeningPackage.PackageName);
	jQuery('#screening-item-description').html(screeningPackage.PackageDescription);

	jQuery('#screening-info').dialog({
		modal: true,
		resizable: false,
		title: jQuery('#screening-type option:selected').text(),
		width: 510,
		height: 500,
		buttons: {}
	});
}

function PreviewScreening() {
	jQuery('#screening-info-header').html('Sample Email:');
	var selectedPackage = null;
	for (var i = 0; i < settings.ScreeningPackages.length; i++) {
		if (settings.ScreeningPackages[i].ScreeningPackageId == parseInt(jQuery('#screening-type').val()))
			selectedPackage = settings.ScreeningPackages[i];
	}

	jQuery('#screening-item-list').html(TranslateTokensScreening(TranslateTokensScreening(settings.ScreeningEmailTemplate, selectedPackage), selectedPackage));

	jQuery('#screening-info').dialog({
		modal: true,
		resizable: false,
		title: 'Screening Invite Preview',
		width: 700,
		height: 600,
		buttons: {}
	});
}

function ScreeningPackageChanged() {
	jQuery('#screening-preview,#screening-viewpackage').button('option', 'disabled', (jQuery('#screening-type').val() == '0'));

	if ((selectedContacts.length == 0 && !hasUpload) || jQuery('#screening-type').val() == '0')
		jQuery('#screening-send').button('option', 'disabled', true);
	else if ((selectedContacts.length > 0 || hasUpload) && jQuery('#screening-type').val() != '0')
		jQuery('#screening-send').button('option', 'disabled', false);
}

var hasUpload = false;

function InitializeNewScreening() {
	let initScreenings = function () {
		jQuery('#screening-addpart, #screening-viewpackage').css('width', '190px');
		jQuery('#screening-send,#screening-preview,#screening-addpart, #screening-viewpackage').button();
		jQuery('#screening-send,#screening-preview,#screening-viewpackage').button('option', 'disabled', true);
		var dlgWidth = 975;

		if (settings.ScreeningPaymentDefaultMethod) {
			if (settings.ScreeningPaymentDefaultMethod.toLowerCase() == 'sender')
				jQuery('#screening-payment-sender').prop('checked', true);
			else
				jQuery('#screening-payment-recipient').prop('checked', true);
		}
		if (settings.IsScreeningPaymentRO)
			jQuery('#screening-payment-sender, #screening-payment-recipient').prop('disabled', true);

		if (isProjectWall()) {
			jQuery('#screening-upload,#screening-notes-separator,#screening-notes-header,#screening-notes,#screening-preview,#screening-addcontainer,#label-screening-to,#screening-header-top').css('display', 'none');
			jQuery('#screening-preview2').css('display', '');
			jQuery('#screening-header').css('width', '100%');
			dlgWidth = 800;
		}
		else {
			var pmUploadURL = PJQ.app.options.uploadUrl + '/DesktopModules/PanteraModuleGlobal/FileUpload/FileTransferHandler.ashx?folder=0&uid=' + settings.FileUploadContext + '&sid=' + pjqSessionId;
			jQuery('#fileupload2').attr('action', pmUploadURL);
			jQuery('#fileupload2').fileupload();
			jQuery('#fileupload2').fileupload('option', {
				autoUpload: true,
				url: pmUploadURL,
				dropZone: jQuery('#fileupload2'),
				add: function (e, data) {
					var goUpload = true;
					var uploadFile = data.files[0];
					if (!(/\.(xls|xlsx)$/i).test(uploadFile.name)) {
						showInfoDialogAB('Unsupported File Type', 'Please upload only Excel documents.');
						goUpload = false;
					}
					if (goUpload == true) {
						data.submit();
						hasUpload = true;
						ScreeningPackageChanged();
						jQuery('.dropnotice', jQuery('#screening-files')).css('display', 'none');
					}
				}
			});

			jQuery('#fileupload2').bind('fileuploadalways', function (e, data) {
				jQuery('.dropnotice', jQuery('#screening-files')).css('display', 'none');
			});

			jQuery('#fileupload2').bind('fileuploaddestroy', function (e, data) {
				if (jQuery("#screening-files table[role='presentation'] tbody tr").length > 0) {

					if (selectedContacts.length > 0 && jQuery('#screening-type').val() != '0')
						jQuery('#screening-send').button('option', 'disabled', false);
					jQuery('.dropnotice', jQuery('#screening-files')).css('display', 'none');
				}
				else {
					if (selectedContacts.length == 0)
						jQuery('#screening-send').button('disable');
					jQuery('.dropnotice', jQuery('#screening-files')).css('display', '');
				}
			});

			jQuery('#screening-payment-sender, #screening-payment-recipient').off();
			jQuery('#screening-payment-sender, #screening-payment-recipient').on('change', function () {
				if ((jQuery('#screening-payment-sender').prop('checked') || jQuery('#screening-payment-recipient').prop('checked')) && selectedContacts.length > 0 && jQuery('#screening-type').val() != '0')
					jQuery('#screening-send').button('enable');
				else
					jQuery('#screening-send').button('disable');
			})
			jQuery('#screening-payment-sender').trigger('change');

			if (jQuery(document).width() > 1024)
				dlgWidth = jQuery(document).width() * 0.90;
		}

		var windowTitle = 'New Qualification Request ';
		if (selectedContacts.length > 0) {
			windowTitle += ' - ' + selectedContacts.length.toString() + ' Contacts';
			if ((jQuery('#screening-payment-sender').prop('checked') || jQuery('#screening-payment-recipient').prop('checked')) && selectedContacts.length > 0 && jQuery('#screening-type').val() != '0')
				jQuery('#screening-send').button('option', 'disabled', false);
		}

		if (jQuery('#screening-type option').length == 0) {
			jQuery('#screening-type').append("<option value='0'>Select...</option>");
			for (var i = 0; i < settings.ScreeningPackages.length; i++) {
				jQuery('#screening-type').append("<option value='" + settings.ScreeningPackages[i].ScreeningPackageId.toString() + "'>" + settings.ScreeningPackages[i].PackageName + " (" + settings.ScreeningPackages[i].ItemCount.toString() + " Items)</option>");
			}
		}

		if (jQuery('#screening-type').val() == '0')
			jQuery('#screening-type').val(settings.ScreeningPackages[0].ScreeningPackageId.toString());

		if ((selectedContacts.length == 0 && !hasUpload) || jQuery('#screening-type').val() == '0')
			jQuery('#screening-preview').button('option', 'disabled', true);
		else if ((selectedContacts.length > 0 || hasUpload) && jQuery('#screening-type').val() != '0')
			jQuery('#screening-preview').button('option', 'disabled', false);

		if (settings.IsDodgeCRM) {
			jQuery('#screening-payment-sender').prop('checked', true);
			jQuery('.dodgecrm-hide').hide();
		}

		dlgScreen = jQuery('#screening-window').dialog({
			modal: true,
			resizable: false,
			title: windowTitle,
			width: dlgWidth,
			buttons: {}
		});
	};
	if (jQuery('#screening-window').length == 0) {
		let template = 'NewScreening',
			sessionMasterUserId = PJQ.app.session.get('masterUserId');
		if (sessionMasterUserId === 113992) {
			template += '_113992';
		}
		PJQ.templating.TemplateRenderer.renderTemplate(true, new PJQ.templating.Template(PJQ.constants.modules.PJQADDRESSBOOK, template, {
			isOldModule: true
		}), jQuery('#pjq-main'), null, function () {
			initScreenings();
		});
	}
	else {
		initScreenings();
	}
}

function ScreeningAddFromAB() {
	jQuery('#screening-window').dialog('close');
	jQuery('#screening-new').button('option', 'label', 'Resume Request');
	settings.AddressBookContext = 'scr';
	pjqABContext = 'scr';
	InitializeGridMain(gridMainView);
}

function SendScreeningHelper() {
	showInfoDialogAB('Confirm Order', 'Are you sure you want to place this order and send these requests?.', 'ui-icon-alert', 'screening-send-confirm');
}

function SendScreening() {
	if (!jQuery('#screening-payment-sender').prop('checked') && !jQuery('#screening-payment-recipient').prop('checked')) {
		jQuery('#screening-payment').append('<div id="screening-payment-error" style="color:red;font-size:12px;margin-left:5px;">Please select a payment type.</div>');
		return;
	}
	else
		jQuery('#screening-payment-error').remove();

	jQuery('#screening-window').dialog('close');
	jQuery('#screening-new').button('option', 'label', 'Request Qualification');

	// do the check to make sure none of these contacts have recently received this package
	$.getJSON("/DesktopModules/PJQAddressBook/CheckScreeningPackageContacts.aspx?sessionId=" + pjqSessionId + "&p=" + parseInt(jQuery('#screening-type').val()) + "&c=" + selectedContacts.join(',') + "&x=" + (new Date).getTime(), function (data) {
		if (data.d.DisabledRows.length == 0)
			SendScreeningFinal();
		else if (data.d.DisabledRows.length == selectedContacts.length) {
			showInfoDialogAB('Request Error', 'The selected Contacts already have this package in effect, or do not have an Email Address.  They cannot be re-ordered until 30 days prior to expiration.', 'ui-icon-alert');
		}
		else {

			var valid = selectedContacts.length - data.d.DisabledRows.length;
			var msg = data.d.DisabledRows.length.toString() + ' selected Contacts already have this package in effect, or do not have an Email Address.   Click OK to send to the remaining ' + valid.toString() + ' contacts, or Cancel to cancel.<br />';
			jQuery('#screening-package-contacts-header').html(msg);
			for (var i = 0; i < data.d.DisabledRows.length; i++) {
				jQuery('#screening-package-contact-list').append(data.d.DisabledRows[i] + '<br/>');
			}

			jQuery('#screening-package-contacts').dialog({
				modal: true,
				resizable: false,
				title: 'Request Error',
				width: 400,
				buttons: {
					Ok: function () {
						jQuery(this).dialog('close');
						SendScreeningFinal();
					},
					Cancel: function () {
						jQuery(this).dialog('close');
					}
				}
			});

		}
	});

}


function SendScreeningFinal() {
	var projectId = null;
	if (isProjectWall())
		projectId = project.ProjectId;

	PanteraScript.PanteraScriptService.SendScreeningRequest(pjqSessionId, parseInt(jQuery('#screening-type').val()), projectId, jQuery('#screening-payment-recipient').prop('checked'), jQuery('#screening-body').val(), selectedContacts.join(','), settings.FileUploadContext, '', SendScreeningC, onScriptError);
	selectedContacts = [];
	selectedCompanies = [];
	selectedGroups = [];
	pjqABContext = '';
	jQuery('#screening-type').val('0');
	jQuery('#screening-body').val('');
}

function SendScreeningC(response) {
	if (!isProjectWall()) {
		settings.FileUploadContext = response;
		var pmUploadURL = PJQ.app.options.uploadUrl + '/DesktopModules/PanteraModuleGlobal/FileUpload/FileTransferHandler.ashx?folder=0&uid=' + settings.FileUploadContext + '&sid=' + pjqSessionId;

		jQuery('#fileupload2').attr('action', pmUploadURL);
		jQuery('#fileupload2').fileupload('option', {
			url: pmUploadURL
		});
		jQuery("#screening-files table[role='presentation'] tbody tr").remove();
		jQuery('.dropnotice', jQuery('#screening-files')).css('display', '');
	}

	showInfoDialogAB('Screening Sent', 'Your Screening Request is now being processed for sending.', 'ui-icon-info', 'new-screening-sent');
}


function TranslateTokensScreening(template, selectedPackage) {

	template = template.replace(/\[Package.EmailNote\]/g, selectedPackage.EmailNote);
	template = template.replace(/\[Package.PaymentNote\]/g, selectedPackage.PaymentNote);

	template = template.replace(/\[ScreeningInvite.RSVPURL\]/g, 'http://www.demolink.com/prequal/1T2E3S4T5');
	template = template.replace(/\[Sender.Username\]/g, 'democon');
	template = template.replace(/\[Sender.Company\]/g, 'Demo Contracting, Inc.');
	template = template.replace(/\[Sender.Contact\]/g, 'Demo One');
	template = template.replace(/\[Sender.Address1\]/g, '345 Demo Street');
	template = template.replace(/\[Sender.Address2\]/g, '');
	template = template.replace(/\[Sender.City\]/g, 'McMinnville');
	template = template.replace(/\[Sender.State\]/g, 'OR');
	template = template.replace(/\[Sender.Zip\]/g, '83832');
	template = template.replace(/\[Sender.Country\]/g, 'US');
	template = template.replace(/\[Sender.Phone\]/g, '123-123-1234');
	template = template.replace(/\[Sender.PhoneExtension\]/g, '344');
	template = template.replace(/\[Sender.Fax\]/g, '123-123-1235');
	template = template.replace(/\[Sender.Email\]/g, 'contact1@demo.com');
	template = template.replace(/\[Sender.EmailLogoURL\]/g, '');
	template = template.replace(/\[Sender.FullAddress\]/g, '345 Demo Street  McMinnville, OR 83832');
	template = template.replace(/\[Sender.Email2\]/g, 'contact1b@demo.com');

	template = template.replace(/\[ProjectContact2.Username\]/g, 'democon2');
	template = template.replace(/\[ProjectContact2.Company\]/g, 'Demo Contracting, Inc.');
	template = template.replace(/\[ProjectContact2.Contact\]/g, 'Demo Two');
	template = template.replace(/\[ProjectContact2.Address1\]/g, '345 Demo Street');
	template = template.replace(/\[ProjectContact2.Address2\]/g, '');
	template = template.replace(/\[ProjectContact2.City\]/g, 'McMinnville');
	template = template.replace(/\[ProjectContact2.State\]/g, 'OR');
	template = template.replace(/\[ProjectContact2.Zip\]/g, '83832');
	template = template.replace(/\[ProjectContact2.Country\]/g, 'US');
	template = template.replace(/\[ProjectContact2.Phone\]/g, '123-123-1234');
	template = template.replace(/\[ProjectContact2.PhoneExtension\]/g, '345');
	template = template.replace(/\[ProjectContact2.Fax\]/g, '123-123-1234');
	template = template.replace(/\[ProjectContact2.Email\]/g, 'contact2@demo.com');
	template = template.replace(/\[ProjectContact2.EmailLogoURL\]/g, '');
	template = template.replace(/\[ProjectContact2.FullAddress\]/g, '345 Demo Street  McMinnville, OR 83832');
	template = template.replace(/\[ProjectContact2.Email2\]/g, 'contact2b@demo.com');

	template = template.replace(/\[Recipient.Company\]/g, 'Demo Recipient');
	template = template.replace(/\[Recipient.Contact\]/g, 'Demo Subcontracting, Inc.');
	template = template.replace(/\[Recipient.Title\]/g, 'Estimator');
	template = template.replace(/\[Recipient.Address1\]/g, '234 Demo Street');
	template = template.replace(/\[Recipient.Address2\]/g, '');
	template = template.replace(/\[Recipient.City\]/g, 'Demoville');
	template = template.replace(/\[Recipient.State\]/g, 'AZ');
	template = template.replace(/\[Recipient.Zip\]/g, '98021');
	template = template.replace(/\[Recipient.Country\]/g, 'US');
	template = template.replace(/\[Recipient.Phone\]/g, '123-123-1234');
	template = template.replace(/\[Recipient.PhoneExtension\]/g, '456');
	template = template.replace(/\[Recipient.Fax\]/g, '123-123-1235');
	template = template.replace(/\[Recipient.Email\]/g, 'demo@demo.com');
	template = template.replace(/\[Recipient.EmailLogoURL\]/g, '');
	template = template.replace(/\[Recipient.FullAddress\]/g, '234 Demo Street.  Demoville, AZ 98021');

	template = template.replace(/\[Portal.URL\]/g, 'http://www.demolink.com/');
	template = template.replace(/\[DateTime.Today\]/g, '01/01/2015');

	template = template.replace(/\[Project.ProjectId\]/g, '123456789');
	template = template.replace(/\[Project.Name\]/g, 'Demo Project');
	template = template.replace(/\[Project.Address1\]/g, '123 Demo St.');
	template = template.replace(/\[Project.Address2\]/g, '');
	template = template.replace(/\[Project.City\]/g, 'Pleasant Prairie');
	template = template.replace(/\[Project.State\]/g, 'WI');
	template = template.replace(/\[Project.Zip\]/g, '53012');
	template = template.replace(/\[Project.Country\]/g, 'US');
	template = template.replace(/\[Project.Notes\]/g, 'Demo Notes');
	template = template.replace(/\[Project.ResponseDueLabel\]/g, '');
	template = template.replace(/\[Project.ResponseDueDate\]/g, '');
	template = template.replace(/\[Project.ResponseDueTime\]/g, '');
	template = template.replace(/\[Project.ResponseDueTimeZone\]/g, '');
	template = template.replace(/\[Project.ResponseDueDateWithBy\]/g, '');
	template = template.replace(/\[Project.CustomFieldLabel1\]/g, '');
	template = template.replace(/\[Project.CustomFieldValue1\]/g, '');
	template = template.replace(/\[Project.CustomFieldLabel2\]/g, '');
	template = template.replace(/\[Project.CustomFieldValue2\]/g, '');
	template = template.replace(/\[Project.CustomFieldLabel3\]/g, '');
	template = template.replace(/\[Project.CustomFieldValue3\]/g, '');
	template = template.replace(/\[Project.CustomFieldLabel4\]/g, '');
	template = template.replace(/\[Project.CustomFieldValue4\]/g, '');
	template = template.replace(/\[Project.CustomFieldLabel5\]/g, '');
	template = template.replace(/\[Project.CustomFieldValue5\]/g, '');
	template = template.replace(/\[Project.CustomFieldLabel6\]/g, '');
	template = template.replace(/\[Project.CustomFieldValue6\]/g, '');
	template = template.replace(/\[Project.CustomFieldLabel7\]/g, '');
	template = template.replace(/\[Project.CustomFieldValue7\]/g, '');
	template = template.replace(/\[Project.CustomFieldLabel8\]/g, '');
	template = template.replace(/\[Project.CustomFieldValue8\]/g, '');
	template = template.replace(/\[Project.CustomFieldLabel9\]/g, '');
	template = template.replace(/\[Project.CustomFieldValue9\]/g, '');
	template = template.replace(/\[Project.CustomFieldLabel10\]/g, '');
	template = template.replace(/\[Project.CustomFieldValue10\]/g, '');
	template = template.replace(/\[Project.CustomFieldLabel11\]/g, '');
	template = template.replace(/\[Project.CustomFieldValue11\]/g, '');
	template = template.replace(/\[Project.CustomFieldLabel12\]/g, '');
	template = template.replace(/\[Project.CustomFieldValue12\]/g, '');
	template = template.replace(/\[Project.CustomFieldLabel13\]/g, '');
	template = template.replace(/\[Project.CustomFieldValue13\]/g, '');
	template = template.replace(/\[Project.CustomFieldLabel14\]/g, '');
	template = template.replace(/\[Project.CustomFieldValue14\]/g, '');
	template = template.replace(/\[Project.CustomFieldLabel15\]/g, '');
	template = template.replace(/\[Project.CustomFieldValue15\]/g, '');
	template = template.replace(/\[Project.CustomFieldLabel16\]/g, '');
	template = template.replace(/\[Project.CustomFieldValue16\]/g, '');
	template = template.replace(/\[Project.CustomFieldLabel17\]/g, '');
	template = template.replace(/\[Project.CustomFieldValue17\]/g, '');
	template = template.replace(/\[Project.CustomFieldLabel18\]/g, '');
	template = template.replace(/\[Project.CustomFieldValue18\]/g, '');
	template = template.replace(/\[Project.CustomFieldLabel19\]/g, '');
	template = template.replace(/\[Project.CustomFieldValue19\]/g, '');
	template = template.replace(/\[Project.CustomFieldLabel20\]/g, '');
	template = template.replace(/\[Project.CustomFieldValue20\]/g, '');
	template = template.replace(/\[Project.CustomFieldLabel21\]/g, '');
	template = template.replace(/\[Project.CustomFieldValue21\]/g, '');
	template = template.replace(/\[Project.CustomFieldLabel22\]/g, '');
	template = template.replace(/\[Project.CustomFieldValue22\]/g, '');
	template = template.replace(/\[Project.CustomFieldLabel23\]/g, '');
	template = template.replace(/\[Project.CustomFieldValue23\]/g, '');
	template = template.replace(/\[Project.CustomFieldLabel24\]/g, '');
	template = template.replace(/\[Project.CustomFieldValue24\]/g, '');
	template = template.replace(/\[Project.CustomFieldLabel25\]/g, '');
	template = template.replace(/\[Project.CustomFieldValue25\]/g, '');
	template = template.replace(/\[Project.CustomFieldLabel26\]/g, '');
	template = template.replace(/\[Project.CustomFieldValue26\]/g, '');
	template = template.replace(/\[Project.CustomFieldLabel27\]/g, '');
	template = template.replace(/\[Project.CustomFieldValue27\]/g, '');
	template = template.replace(/\[Project.CustomFieldLabel28\]/g, '');
	template = template.replace(/\[Project.CustomFieldValue28\]/g, '');
	template = template.replace(/\[Project.CustomFieldLabel29\]/g, '');
	template = template.replace(/\[Project.CustomFieldValue29\]/g, '');
	template = template.replace(/\[Project.CustomFieldLabel30\]/g, '');
	template = template.replace(/\[Project.CustomFieldValue30\]/g, '');
	template = template.replace(/\[Project.CustomFieldLabel31\]/g, '');
	template = template.replace(/\[Project.CustomFieldValue31\]/g, '');
	template = template.replace(/\[Project.CustomFieldLabel32\]/g, '');
	template = template.replace(/\[Project.CustomFieldValue32\]/g, '');
	template = template.replace(/\[Project.CustomFieldLabel33\]/g, '');
	template = template.replace(/\[Project.CustomFieldValue33\]/g, '');
	template = template.replace(/\[Project.CustomFieldLabel34\]/g, '');
	template = template.replace(/\[Project.CustomFieldValue34\]/g, '');
	template = template.replace(/\[Project.CustomFieldLabel35\]/g, '');
	template = template.replace(/\[Project.CustomFieldValue35\]/g, '');
	template = template.replace(/\[Project.CustomFieldLabel36\]/g, '');
	template = template.replace(/\[Project.CustomFieldValue36\]/g, '');
	template = template.replace(/\[Project.CustomFieldLabel37\]/g, '');
	template = template.replace(/\[Project.CustomFieldValue37\]/g, '');
	template = template.replace(/\[Project.CustomFieldLabel38\]/g, '');
	template = template.replace(/\[Project.CustomFieldValue38\]/g, '');
	template = template.replace(/\[Project.CustomFieldLabel39\]/g, '');
	template = template.replace(/\[Project.CustomFieldValue39\]/g, '');
	return template;
}

function isProjectWall() {
	if (settings.AddressBookTabId)
		return true;
	else
		return false;
}

function ScreeningItemDetailDelete(sender) {
	lastScreeningCommentId = parseInt(jQuery(sender).attr('pjq-sicc'));
	showInfoDialogAB('Delete Comment', 'Are you sure you want to delete this Comment?', 'ui-icon-alert', 'screening-comment-delete');
}

function ScreeningCommentDelete() {
	PanteraScript.PanteraScriptService.DeleteScreeningContactCompanyItemCommentAdmin(pjqSessionId, lastScreeningCommentId, ItemDetailC, onScriptError);
}

function ScreeningItemDetailDownload(sender) {
	// pjqDL($(sender).attr('pjq-siue'));
	PJQ.files.downloadFile(PJQ.helpers.urlHelpers.generateEndpoint([
		{
			endpoint: 'files',
			value: $(sender).attr('pjq-siue')
		},
		{
			endpoint: 'downloadentryid'
		}
	]), {
		isEndpoint: true,
		isApi2: true
	});
}

function ScreeningItemComment(sender) {
	var si = jQuery(sender).attr('pjq-si');
	var sic = jQuery(sender).attr('pjq-sic');
	jQuery('#screening-comment').val('');
	jQuery('#screening-comment-visible-recipient,#screening-comment-notify-proqual').prop('checked', false);
	jQuery('#screening-comment-visible').buttonset();
	jQuery('#screening-comment-visible-internal').prop('checked', true);
	var myTitle = 'Add Comment for Item';
	var subgrid = gridScreening.cells(sic, 0).getSubGrid();
	myTitle = myTitle + ' - ' + $('<textarea />').html(subgrid.cells(si, 1).getValue()).text();

	if (settings.IsDodgeCRM)
		jQuery('label[for="screening-comment-notify-proqual"]').text('Notify Qualifications Team');
	else if (settings.IsDodgeWG)
		jQuery('label[for="screening-comment-notify-proqual"]').text('Notify Dodge Staff');

	var $cdlg = jQuery("#dialog-add-screening-comment"),
		dlg = $cdlg.dialog({
			resizable: false,
			height: 320,
			width: 600,
			title: myTitle,
			modal: true,
			draggable: false,
			open: function () {
				$cdlg.find('#screening-comment-notify-proqual').prop('checked', true);
			},
			buttons: {
				"Save Comment": function () {
					if (jQuery('#screening-comment').val().trim().length == 0) {
						showInfoDialogAB('Invalid Submission', 'Please enter a comment before clicking \'Save Comment\'', 'ui-icon-alert');
						return;
					}
					PanteraScript.PanteraScriptService.AddScreeningContactCompanyItemCommentAdmin(pjqSessionId, editContact.ContactCompanyId, parseInt(si), jQuery('#screening-comment-visible-recipient').prop('checked'), jQuery('#screening-comment-notify-proqual').prop('checked'), jQuery('#screening-comment').val(), ItemDetailC, onScriptError);

					jQuery(this).dialog('close');
				}
			}
		});

}

function ScreeningItemUpload(sender) {
	jQuery('#screening-upload-si').val(jQuery(sender).attr('pjq-si'));
	jQuery('#screening-upload-sic').val(jQuery(sender).attr('pjq-sic'));
	PanteraScript.PanteraScriptService.GetNewGuid(ScreeningItemUploadC, onScriptError);
}

function ScreeningItemUploadC(response) {
	jQuery('#screening-upload-guid').val(response);
	var pmUploadURL = PJQ.app.options.uploadUrl + '/DesktopModules/PanteraModuleGlobal/FileUpload/FileTransferHandler.ashx?folder=0&uid=' + response + '&sid=' + pjqSessionId;
	jQuery('#fileuploadSI').attr('action', pmUploadURL);
	jQuery('#fileuploadSI').fileupload();
	jQuery('#fileuploadSI').fileupload('option', {
		autoUpload: true,
		url: pmUploadURL,
		dropZone: jQuery('#fileuploadSI'),
		add: function (e, data) {
			var goUpload = true;
			var uploadFile = data.files[0];
			/*
			if (!(/\.(xls|xlsx)$/i).test(uploadFile.name)) {
			showInfoDialogAB('Unsupported File Type','Please upload only Excel documents.');
			goUpload = false;
			}
			 */
			if (goUpload == true) {
				data.submit();
				jQuery('.dropnotice', jQuery('#screening-upload-files')).css('display', 'none');
			}
		}
	});

	jQuery('#fileuploadSI').bind('fileuploadalways', function (e, data) {
		jQuery('.dropnotice', jQuery('#screening-upload-files')).css('display', 'none');
	});

	jQuery('#fileuploadSI').bind('fileuploaddestroy', function (e, data) {
		if (jQuery("#screening-upload-files table[role='presentation'] tbody tr").length > 0) {

			jQuery('.dropnotice', jQuery('#screening-upload-files')).css('display', 'none');
		}
		else {
			jQuery('.dropnotice', jQuery('#screening-upload-files')).css('display', '');
		}
	});

	var myTitle = 'Upload File(s) for Item';
	var subgrid = gridScreening.cells(jQuery('#screening-upload-sic').val(), 0).getSubGrid();
	myTitle = myTitle + ' - ' + $('<textarea />').html(subgrid.cells(jQuery('#screening-upload-si').val(), 1).getValue()).text();
	jQuery('#screening-upload-files table tbody.files tr').remove();
	jQuery('.dropnotice', jQuery('#screening-upload-files')).css('display', '');
	var dlg = jQuery("#dialog-add-screening-upload").dialog({
		resizable: false,
		height: 420,
		width: 600,
		title: myTitle,
		modal: true,
		draggable: false,
		buttons: {
			"Save Files": function () {
				if (jQuery('#screening-upload-files table tbody.files tr').length == 0) {
					alert('Please upload at least one file to continue.');
					return;
				}
				PanteraScript.PanteraScriptService.AddScreeningContactCompanyItemUploadAdmin(pjqSessionId, editContact.ContactCompanyId, parseInt(jQuery('#screening-upload-si').val()), editContact.ContactId, jQuery('#screening-upload-guid').val(), ItemDetailC, onScriptError);
				jQuery(this).dialog('close');
			}
		}
	});
}

function initScreeningFilters() {
	jQuery('#screening-new').button({
		icons: {
			primary: 'ui-icon-screening-new',
			secondary: null
		}
	});
	jQuery("#filter-all").button({
		icons: {
			primary: 'ui-icon-screening-all',
			secondary: null
		}
	});
	jQuery("#filter-pending").button({
		icons: {
			primary: 'ui-icon-screening-pending',
			secondary: null
		}
	});
	jQuery("#filter-inprocess").button({
		icons: {
			primary: 'ui-icon-screening-inprocess',
			secondary: null
		}
	});
	jQuery("#filter-allclear").button({
		icons: {
			primary: 'ui-icon-screening-allclear',
			secondary: null
		}
	});
	jQuery("#filter-review").button({
		icons: {
			primary: 'ui-icon-screening-review',
			secondary: null
		}
	});
	jQuery("#filter-grade").button({
		icons: {
			primary: 'ui-icon-screening-grade',
			secondary: null
		}
	});
	jQuery("#filter-processed").button({
		icons: {
			primary: 'ui-icon-screening-processed',
			secondary: null
		}
	});
	jQuery("#filter-expired").button({
		icons: {
			primary: 'ui-icon-screening-expired',
			secondary: null
		}
	});
	jQuery("#filter-inactive").button({
		icons: {
			primary: 'ui-icon-screening-inactive',
			secondary: null
		}
	});
	jQuery('#screening-status input[type=radio]').change(function () {
		lastFilter = this.id;
		InitializeGridMain(gridMainView);
		//SetABSPc();
	});

	if (!settings.CanSendScreeningRequests)
		$('#screening-new').attr("disabled", true);

	jQuery("label[for='filter-all'] span.ui-button-text").text("All Companies (" + settings.ScreeningStats.CountAllContacts.toString() + ")");
	jQuery("label[for='filter-pending'] span.ui-button-text").text("Qualification Pending (" + settings.ScreeningStats.CountPending.toString() + ")");
	jQuery("label[for='filter-inprocess'] span.ui-button-text").text("Qualification In Process (" + settings.ScreeningStats.CountInProgress.toString() + ")");

	jQuery("label[for='filter-allclear'] span.ui-button-text").text("Review Complete (" + settings.ScreeningStats.CountApproved.toString() + ")");

	jQuery("label[for='filter-review'] span.ui-button-text").text("Review Needed (" + settings.ScreeningStats.CountReview.toString() + ")");
	jQuery("label[for='filter-grade'] span.ui-button-text").text("Feedback Required (" + settings.ScreeningStats.CountFeedback.toString() + ")");
	jQuery("label[for='filter-processed'] span.ui-button-text").text("All Enrolled (" + settings.ScreeningStats.CountEnrolled.toString() + ")");
	jQuery("label[for='filter-expired'] span.ui-button-text").text("Qualification Expired (" + settings.ScreeningStats.CountExpired.toString() + ")");
	jQuery('#divRight').width("83%");
	jQuery('#divLeft').show();
}